document.addEventListener("DOMContentLoaded", () => {

    const searchDrawer = document.getElementById("awSearchDrawer");
    const searchOpenBtns = document.querySelectorAll('[aria-label="Search"]');
    const searchCloseBtn = document.getElementById("awSearchClose");

    const searchInput = document.getElementById("awPredictiveSearchInput");
    const searchResults = document.getElementById("awPredictiveSearchResults");

    // ==========================================
    // OPEN SEARCH
    // ==========================================
    searchOpenBtns.forEach(btn => {

        btn.addEventListener("click", () => {

            searchDrawer.classList.add("active");

            document.body.classList.add("aw-search-open");

            setTimeout(() => {
                searchInput.focus();
            }, 200);

        });

    });

    // ==========================================
    // CLOSE SEARCH
    // ==========================================
    function closeSearchDrawer() {

        searchDrawer.classList.remove("active");

        document.body.classList.remove("aw-search-open");

    }

    searchCloseBtn.addEventListener("click", closeSearchDrawer);

    // ESC CLOSE
    document.addEventListener("keydown", (e) => {

        if (e.key === "Escape") {

            closeSearchDrawer();

        }

    });

    // OVERLAY CLICK CLOSE
    searchDrawer.addEventListener("click", (e) => {

        if (e.target === searchDrawer) {

            closeSearchDrawer();

        }

    });

    // ==========================================
    // PREDICTIVE SEARCH
    // ==========================================
    let searchTimeout;

    searchInput.addEventListener("input", () => {

        clearTimeout(searchTimeout);

        const query = searchInput.value.trim();

        if (query.length < 2) {

            searchResults.innerHTML = "";

            return;

        }

        searchTimeout = setTimeout(async () => {

            try {

                searchResults.innerHTML =
                    '<div class="aw-search-loading">Searching...</div>';

                const response = await fetch(
                    `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`
                );

                const text = await response.text();

                const html = new DOMParser()
                    .parseFromString(text, "text/html");

                const resultsMarkup =
                    html.querySelector("#shopify-section-predictive-search");

                if (resultsMarkup) {

                    searchResults.innerHTML = resultsMarkup.innerHTML;

                } else {

                    searchResults.innerHTML =
                        '<div class="aw-no-results">No results found.</div>';

                }

            } catch (error) {

                console.error("Predictive Search Error:", error);

                searchResults.innerHTML =
                    '<div class="aw-no-results">Something went wrong.</div>';

            }

        }, 300);

    });

});